import { useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router';

import { OrderTab } from '../types.ts';

const useActiveOrderTab = (): OrderTab => {
  const isArchived = useMatch('archived-orders');
  const isTraining = useMatch('training-orders');
  const isCompleted = useMatch('completed-orders');

  if (isTraining) return 'training';
  if (isArchived) return 'archived';
  if (isCompleted) return 'completed';
  return 'active';
};

const useSetActiveOrderTab = () => {
  const navigate = useNavigate();

  return useCallback(
    (tab: OrderTab) => {
      switch (tab) {
        case 'active':
          navigate('/orders');
          break;
        case 'archived':
          navigate('/archived-orders');
          break;
        case 'training':
          navigate('/training-orders');
          break;
        case 'completed':
          navigate('/completed-orders');
          break;
      }
    },
    [navigate],
  );
};

export const useActiveOrderTabState = (): [OrderTab, (val: OrderTab) => void] => {
  const activeOrderTab = useActiveOrderTab();
  const setActiveOrderTab = useSetActiveOrderTab();

  return [activeOrderTab, setActiveOrderTab];
};
